import Alert from './src/alert';

module.exports = Alert;


// WEBPACK FOOTER //
// ./src/components/alert/index.js